import { isNumber } from 'lodash'

export default {
  HSSPD: (user) => {
    const confirmedPersonalInfo = user.ConfirmedPersonalInfo
    return !isNumber(confirmedPersonalInfo) || confirmedPersonalInfo < 1
  },
}
